// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 5px;
  border: 1px solid transparent;
  background: #e2e2e2;
  transition: all ease-in 0.4s;
}
.input__wrapper.focused {
  border-color: var(--dark-primary-color) var(--dark-primary-color) var(--dark-primary-color) var(--dark-primary-color);
}
.input__wrapper.warning {
  border-color: var(--error);
}
.form__input {
  position: relative;
  width: 100%;
  background: #e2e2e2;
  color: #404040;
  font-weight: 300;
  transition: 0.4s;
}
.form__input.large,
input.form__input.large[type="file"] {
  height: 37rem;
  padding: 0 11rem 6rem 11rem;
  font-size: 14rem;
  line-height: 37rem;
}
.form__input.medium,
input.form__input.medium[type="file"] {
  height: 27rem;
  padding: 0 8rem 4rem 8rem;
  font-size: 14rem;
  line-height: 27rem;
}
.form__input.small,
input.form__input.small[type="file"] {
  height: 20rem;
  padding: 2rem 6rem;
  font-size: 10rem;
  line-height: 20rem;
}
.form__input::placeholder {
  color: rgba(64, 64, 64, 0.7);
}
.form__input_error {
  color: var(--error);
}
input.form__input[type="file"]::-webkit-file-upload-button {
  border: 1px solid transparent;
  border-radius: 5rem;
  font-size: 14rem;
  letter-spacing: 0.02em;
  transition: 0.4s;
  border-color: var(--gray);
  background-color: var(--gray);
  color: white;
}
input.form__input[type="file"]::-webkit-file-upload-button:hover {
  border-color: #353535;
  background-color: #353535;
  cursor: pointer;
}
input.form__input[type="file"]::-webkit-file-upload-button:disabled {
  border-color: var(--light-gray);
  background-color: transparent;
  color: var(--light-gray);
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/shared/ui/Input/Input.style.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;EACA,4BAAA;AACJ;AACI;EACI,qHAAA;AACR;AAEI;EACI,0BAAA;AAAR;AAIA;EACI,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAFJ;AAKA;;EAEI,aAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;AAHJ;AAMA;;EAEI,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AAJJ;AAOA;;EAEI,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AALJ;AASA;EACI,4BAAA;AAPJ;AAUA;EACI,mBAAA;AARJ;AAWA;EACI,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;EACA,6BAAA;EACA,YAAA;AATJ;AAWI;EACI,qBAAA;EACA,yBAAA;EACA,eAAA;AATR;AAYI;EACI,+BAAA;EACA,6BAAA;EACA,wBAAA;EACA,mBAAA;AAVR","sourcesContent":[".input__wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-right: 5px;\n    border: 1px solid transparent;\n    background: #e2e2e2;\n    transition: all ease-in .4s;\n\n    &.focused {\n        border-color: var(--dark-primary-color) var(--dark-primary-color) var(--dark-primary-color) var(--dark-primary-color);\n    }\n\n    &.warning {\n        border-color: var(--error);\n    }\n}\n\n.form__input {\n    position: relative;\n    width: 100%;\n    background: #e2e2e2;\n    color: #404040;\n    font-weight: 300;\n    transition: .4s;\n}\n\n.form__input.large,\ninput.form__input.large[type=\"file\"] {\n    height: 37rem;\n    padding: 0 11rem 6rem 11rem;\n    font-size: 14rem;\n    line-height: 37rem;\n}\n\n.form__input.medium,\ninput.form__input.medium[type=\"file\"] {\n    height: 27rem;\n    padding: 0 8rem 4rem 8rem;\n    font-size: 14rem;\n    line-height: 27rem;\n}\n\n.form__input.small,\ninput.form__input.small[type=\"file\"] {\n    height: 20rem;\n    padding: 2rem 6rem;\n    font-size: 10rem;\n    line-height: 20rem;\n}\n\n\n.form__input::placeholder {\n    color: rgb(64 64 64 / .7);\n}\n\n.form__input_error {\n    color: var(--error);\n}\n\ninput.form__input[type=\"file\"]::-webkit-file-upload-button {\n    border: 1px solid transparent;\n    border-radius: 5rem;\n    font-size: 14rem;\n    letter-spacing: .02em;\n    transition: .4s;\n    border-color: var(--gray);\n    background-color: var(--gray);\n    color: white;\n\n    &:hover {\n        border-color: #353535;\n        background-color: #353535;\n        cursor: pointer;\n    }\n\n    &:disabled {\n        border-color: var(--light-gray);\n        background-color: transparent;\n        color: var(--light-gray);\n        cursor: not-allowed;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
